import ProjectMenuButton from './ProjectMenuButton';
import withProjects from '/containers/withProjects';

export default withProjects(ProjectMenuButton);
